// import image1 from '@/assets/images/news/detail/20200505/1.jpg';

export default {
  id: '20200505', //  模块 id
  title: '叮咚买菜“五五购物节”拉动消费1.2亿元 日交易额增长近40%', // 标题
  origin: '2020-05-05 21:15:36 来源：上海证券报·中国证券网', // 新闻来源
  editor: '作者：宋薇萍', // 编辑者
  content: [
    {
      type: 0,
      text:
        '上证报中国证券网讯（记者 宋薇萍）记者5月5日从叮咚买菜获悉，在“五五购物节”带动下，上海消费者在“叮咚买菜”上的购物热情高涨，从5月1日至今，叮咚买菜的促销补贴金额已超过2000万元，拉动消费超过1.2亿元。目前，上海地区每日交易额超过3000万元，比平时增长近40%。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '5月4日晚，上海国际消费城市全球推介大会暨“五五购物节”启动仪式盛大开幕。叮咚买菜CEO梁昌霖作为企业代表出席了启动仪式，并介绍了叮咚买菜在购物节期间的促销活动亮点。梁昌霖说，作为上海本土生鲜电商平台，叮咚买菜全力支持“五五购物节”，在购物节期间优惠超过2亿元，数百款产品买一送一，时令食材0元尝鲜。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '据统计，“五五购物节”期间，最受上海市民欢迎的促销活动莫过于0元秒杀、55大额消费券及水产满赠活动。为了让上海市民品尝到最新鲜的时令味道，叮咚买菜准备了数万份时令新品，比如妃子笑荔枝等，均以0元销售，以飨消费者。据悉，这些新品往往两分钟内就被消费者抢购一空。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '随着天气日渐炎热，购物节期间最受欢迎的产品是夏季爆款小龙虾，日均销量超3万斤，同比增长近550%。小龙虾销量暴增也带动了啤酒、小龙虾调料等周边产品的消费。叮咚买菜上售卖的鲜活小龙虾来自江苏泗洪和湖北梁子湖。新鲜小龙虾都为“当日达”，即早上从产地池塘起货，下午就送到上海。随着叮咚买菜等生鲜电商的兴起，“鲜活小龙虾原产地直采送到家”已成为潮流。',
      isIndent: false,
    },
  ],
};
